import { ROUTES } from "../constants";

export interface PostLoginResponse {
  paymentMethods: {
    paymentMethodName: string;
    paymentMethodDisplayName: string;
    paymentMethodAssetUrl: string;
  }[];
  playerCurrencyCode: string;
}

export const getPostLogin = async (
  baseUrl: string,
  sessionToken: string,
  onSuccess: (data: PostLoginResponse) => void,
  onBadResponse: (response?: any) => void,
  onError: (error: any) => void
) => {
  try {
    const response = await fetch(`${baseUrl}/${ROUTES.POST_LOGIN}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionToken}`,
      },
    });

    if (response.ok) {
      onSuccess?.(await response.json());
    } else {
      onBadResponse?.(response);
    }
  } catch (error) {
    onError?.(error);
  }
};

export const getPaypalToken = async (
  baseUrl: string,
  sessionToken: string,
  onSuccess: (paypalToken: string) => void,
  onBadResponse: (response?: any) => void,
  onError: (error: any) => void
) => {
  try {
    const response = await fetch(`${baseUrl}/${ROUTES.STORE_PAYPAL_TOKEN}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionToken}`,
      },
    });

    if (response.ok) {
      const data = await response.text();
      onSuccess?.(data);
    } else {
      onBadResponse?.(response);
    }
  } catch (error) {
    onError?.(error);
  }
};
